import React from "react";
import images from "../../../images";
import { toastUtils } from "../../../Utils/helper";

const PowerUpCard = ({
  icon,
  title,
  howToEarn,
  perk,
  referralCode,
  isCompleted = true,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    toastUtils.info("Referral code copied to clipboard!");
  };

  return (
    <div
      className={`flex flex-row justify-start items-start gap-7 border-b border-dotted border-[#253FF6] pb-3 ${
        !isCompleted ? "opacity-40 blur-[1px]" : ""
      }`}
    >
      <div className="flex w-[70px] h-[70px] relative">
        <img src={icon} alt={title} className="object-contain w-full h-full" />
      </div>

      <div className="flex-1">
        <h6
          className={`text-[#253FF6] font-[Figtree] text-[20px] font-bold not-italic leading-[28px]`}
        >
          {title}
        </h6>

        <div className="mt-2 text-[#253FF6] font-[Figtree] text-[14px]">
          <p className=" font-bold not-italic underline">How to earn</p>
          <p className="font-medium not-italic leading-[21px]">{howToEarn}</p>
        </div>
        <div className="mt-4 text-[#253FF6] font-[Figtree] text-[14px]">
          <p className=" font-bold not-italic underline">Perk</p>
          <p className=" font-medium not-italic leading-[21px]">{perk}</p>
        </div>
        {referralCode && (
          <div className="mt-4">
            <p className="text-[#253FF6] font-[Figtree] text-[14px] font-bold not-italic underline">
              Referral Code
            </p>
            <div className="flex items-center gap-2 mt-1 text-2xl font-bold text-[#253FF6]">
              {referralCode}
              <img
                className="w-5 h-5 cursor-pointer"
                src={images.Copy}
                alt=""
                onClick={handleCopy}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PowerUpCard;
